export const GET_PROJECT = 'GET_PROJECT';
export const GET_PUBLIC_PROJECT = 'GET_PUBLIC_PROJECT';
export const GET_SURVEY_QUESTIONS = 'GET_SURVEY_QUESTIONS';
export const GET_SURVEY_GROUPS = 'GET_SURVEY_GROUPS';
export const GET_PUBLIC_SURVEY_QUESTIONS = 'GET_PUBLIC_SURVEY_QUESTIONS';
export const GET_PUBLIC_SURVEY_GROUPS = 'GET_PUBLIC_SURVEY_GROUPS';
export const GET_SURVEY_VIEW_COUNT = 'GET_SURVEY_VIEW_COUNT';
export const GET_SURVEY_RESPONSES = 'GET_SURVEY_RESPONSES';
export const GET_PUBLIC_SURVEY_RESPONSES = 'GET_PUBLIC_SURVEY_RESPONSES';
export const RESET_SURVEY_RESPONSES = 'RESET_SURVEY_RESPONSES';
export const GET_QUESTION_PROPERTY = 'GET_QUESTION_PROPERTY';
export const GET_PUBLIC_QUESTION_PROPERTY = 'GET_PUBLIC_QUESTION_PROPERTY';
export const GET_SURVEY_TIMINGS = 'GET_SURVEY_TIMINGS';
export const GET_PUBLIC_SURVEY_TIMINGS = 'GET_PUBLIC_SURVEY_TIMINGS';
export const GET_QUALTRICS_SURVEY_QUESTIONS = 'GET_QUALTRICS_SURVEY_QUESTIONS';
export const GET_QUALTRICS_SURVEY_RESPONSES = 'GET_QUALTRICS_SURVEY_RESPONSES';
